import React from 'react';
import { Container, Paper, Title, Text, Box, Center } from '@mantine/core';
import { SignInButton } from './SignInButton';

export const LandingPage: React.FC = () => {
    return (
        <Box
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '2rem 0',
            }}
        >
            <Container size="sm">
                <Paper
                    shadow="xl"
                    radius="lg"
                    p="xl"
                    ta="center"
                >
                    <Title
                        order={1}
                        style={{
                            fontSize: '3rem',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            marginBottom: '0.5rem',
                        }}
                    >
                        Hades
                    </Title>
                    <Text size="xl" c="dimmed" mb="xl">
                        SCIM User Management Interface
                    </Text>
                    <Center mt="xl">
                        <SignInButton />
                    </Center>
                </Paper>
            </Container>
        </Box>
    );
};
